import { ReactComponent } from './counter-plus-s.svg';

export const CounterPlusIconS = ReactComponent;

export default ReactComponent;
